(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-your-stone"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.getElementById('nava-stones-{{ section.id }}');
  if (!root) return;
  // Mobile/touch: tap once to reveal overlay; tap button (or second tap) to navigate
  if (window.matchMedia('(hover: none)').matches){
    root.querySelectorAll('.stone-card').forEach(card=>{
      card.addEventListener('click', (e)=>{
        if (e.target.closest('.btn')) return; // let nav happen
        const isLink = card.tagName === 'A';
        if (isLink && !card.classList.contains('is-open')) e.preventDefault();
        card.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', (e)=>{
      if (!root.contains(e.target)){
        root.querySelectorAll('.stone-card.is-open').forEach(el=>el.classList.remove('is-open'));
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
